import setupCreditsPlansTooltips from "app/components/credits_plans_tooltips"
import { trackCustomPlanRequestClicked, trackCustomPlanRequestShown } from "app/utils/mixpanel_tracking"
import onFirstView from "app/utils/on_first_view"
import openSupportConversation from "app/utils/support_conversation"

export const CUSTOM_PLAN_REQUEST_TAG = "custom_plan_request"
export const CUSTOM_PLAN_REQUEST_MESSAGE = "Hi! I'm interested in a plan tailored to my needs."

type Interval = "monthly" | "yearly"
type PerInterval = Record<Interval, string>

interface Payload {
  prices: Record<string, PerInterval>
  urls: Record<string, PerInterval>
}

// "Contact us" below the cards. Signed out it is a link to the login, which returns to /plans.
const setupCustomPlanRequest = () => {
  const cta = document.querySelector<HTMLElement>("[data-custom-plan-request]")
  if (!cta) return

  const payload = { location: "Plans", tier: window.App.user?.tier ?? "" } as const

  onFirstView(cta.closest(".credits-plans-custom") ?? cta, () => trackCustomPlanRequestShown(payload))
  cta.addEventListener("click", () => {
    trackCustomPlanRequestClicked(payload)
    if (cta instanceof HTMLButtonElement) {
      openSupportConversation({ tag: CUSTOM_PLAN_REQUEST_TAG, message: CUSTOM_PLAN_REQUEST_MESSAGE })
    }
  })
}

// Monthly/yearly switch of the credits /plans page. `prices` and `urls` are keyed by checkout
// key (starter, pro, pro_plus). Checkout links, the card prices and the "billed annually" lines
// follow the switch.
export default function CreditsPlans({ prices, urls }: Payload) {
  setupCreditsPlansTooltips()
  setupCustomPlanRequest()

  const toggle = document.querySelector<HTMLButtonElement>(".credits-plans-toggle .switch-field")
  if (!toggle) return

  const labels = document.querySelectorAll<HTMLElement>(".credits-plans-toggle-label")

  toggle.addEventListener("click", () => {
    const yearly = toggle.getAttribute("aria-checked") !== "true"
    const interval: Interval = yearly ? "yearly" : "monthly"

    toggle.setAttribute("aria-checked", String(yearly))
    toggle.classList.toggle("switch-field-on", yearly)
    labels.forEach(label => label.classList.toggle("is-active", label.dataset.interval === interval))
    document.querySelectorAll<HTMLElement>("[data-plan-billing]").forEach(line => {
      line.hidden = !yearly
    })

    Object.keys(prices).forEach(plan => {
      document.querySelectorAll<HTMLAnchorElement>(`a[data-plan-tier='${plan}']`).forEach(link => {
        link.href = urls[plan][interval]
      })
      document.querySelectorAll<HTMLElement>(`[data-plan-price='${plan}']`).forEach(price => {
        price.textContent = prices[plan][interval]
      })
    })
  })
}
